const { CHANNEL_INTERFACE_TYPE } = require('@/enums');
const { getSupportChannelOptions } = require('@/tools');

module.exports = () => {
  return {
    type: {
      label: '媒体平台',
      type: 'select',
      props: {
        clearable: false,
      },
      options: getSupportChannelOptions()
        .filter(({ value }) => value !== CHANNEL_INTERFACE_TYPE.JRTT_V3),
      value: CHANNEL_INTERFACE_TYPE.JRTT,
    },
    advertiser_id: {
      label: '广告主ID',
      type: 'input',
      value: '',
    },
  };
};

